export default __webpack_public_path__ + "static/media/btn-usplist-up.d70d9094.svg";